import React, { useEffect, useRef, useState } from "react";
import type { NextPage } from "next";
import Image from "next/image";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  FreeMode,
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
} from "swiper";
import Link from "next/link";
import Astrobanner from "@/assets/images/Astro-Banner.jpg";
// import Astrobanner from "@/assets/images/Astro-Banner.jpg.jpg";
import Astroimgq from "@/assets/images/Daily-Horoscope.jpg";
import arrowred from "@/assets/images/icon-right-arrow.svg";
import astw from "@/assets/images/Kudili.jpg";
import aste from "@/assets/images/Astro-Consultation.jpg";
import gline from "@/assets/images/line-gray.png";
import wline from "@/assets/images/white-line.png";
import astroside from "@/assets/images/Why-choose-senco-astro.jpg";
import horoscope_img from "@/assets/images/astro-main-1.png";
import horoscope_img_two from "@/assets/images/astro-main-2.png";
import styles from "@/styles/Astro.module.scss";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { useRouter } from "next/router";
import moment from "moment";
import Layout from "@/layout/layout";
import { wrapper } from "@/store";
import { setPath, setTitle, setMeta } from "@/store/slices/helmet";
SwiperCore.use([FreeMode, Navigation, Thumbs]);
const Astro: NextPage = () => {
  const [astro, setAstro] = useState<any>([]);
  const router = useRouter();
  useEffect(() => {
    loadZodiac();
  }, []);

  const loadZodiac = async () => {
    try {
      const { data } = await httpClient.get(endpoints.astro.zodiacList());
      setAstro(data);
    } catch (error) {}
  };

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return (
    <Layout>
      <div className={styles.astro_banner}>
        <Image src={Astrobanner} alt="" />
        {/* <div className={styles.astro_banner_text}>
          <div className="container h_100">
            <div className={styles.astro_banner_main}>
              <div className={styles.astro_banner_main_text}>
                <h1>
                  <span className="w-100 text-center d-block">
                    {" "}
                    <sup>&ldquo;</sup>Astrology is just a finger pointing at
                    reality <sup>&rdquo;</sup>
                  </span>
                  <span className="w-100 text-end d-block custom_font">
                    – Steven Forrest
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className={styles.astro_bg}>
        <div className={styles.astro_bg_main}>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className={styles.custom_card}>
                  <figure>
                    <Image src={aste} alt="" />
                  </figure>
                  <div className={styles.heading}>Astro Consultation</div>
                  <p>
                    Our astro consultation services are customized to help you
                    gain a deeper understanding of your personal life, health
                    and career.
                  </p>
                  <Link href="/astro/astrologers" passHref>
                    <div className={styles.more}>
                      <span>Book Now</span> <Image src={arrowred} alt="" />{" "}
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className={styles.custom_card}>
                  <figure>
                    <Image src={astw} alt="" />
                  </figure>
                  <div className={styles.heading}>Kundli </div>
                  <p>
                    Your Janam Kundli or Life Kushti can be the success tool of
                    your life. We also specialize in Kundli Matching services.
                  </p>
                  <Link href="/astro/kundali" passHref>
                    <div className={styles.more}>
                      <span>Book Now</span> <Image src={arrowred} alt="" />{" "}
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className={styles.custom_card}>
                  <figure>
                    <Image src={Astroimgq} alt="" />
                  </figure>
                  <div className={styles.heading}>Daily Horoscope</div>
                  <p>
                    Boost your confidence with our Daily Horoscope services
                    based on your zodiac sign. It includes your lucky number and
                    colour as well.
                  </p>
                  <Link href="/astro/horoscope" passHref>
                    <div className={styles.more}>
                      <span>Check Now</span> <Image src={arrowred} alt="" />{" "}
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.about_astro}>
          <div className="container">
            <h2>
              <strong>
                <u>Online Astrological Services</u>
              </strong>{" "}
            </h2>
            <div className={styles.gline}>
              <Image src={gline} alt="" />
            </div>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <p className="text-center">
                  The customized astrological services offered by Senco Gold &
                  Diamonds aim at bringing harmony in one’s life. We have years
                  of experience in guiding people who are wandering without
                  direction and seeking professional guidance. The objective is
                  to help our customers in the best possible way. Daily
                  horoscope services, Kundli services and Astro Consultation
                  services – we offer it all.
                </p>
                <p className="text-center">
                  We also offer Career and Business Horoscope services that
                  include career analysis, favourable periods for career, career
                  yoga and favourable periods for business. We will also let you
                  know the auspicious periods and favourable Dasa Periods that
                  will help you succeed in your career/business. You can choose
                  from a wide range of time periods for Kundli services.
                </p>
                <p className="text-center text-dark">
                  <strong>
                    <u>A Trusted Name for Astrological Gemstones</u>
                  </strong>
                </p>
                <p className="text-center">
                  Discover the world of 100% authentic and certified
                  astrological gemstones at Senco Gold & Diamonds. Our precious
                  gemstones have an alluring splendor and unparalleled hues. Our
                  gemstone experts are equipped with comprehensive knowledge and
                  expertise in the identification, grading, and valuation of
                  gemstones. Visit our stores to discuss your planetary gemstone
                  requirements and choose from a wide range of authentic
                  gemstones.
                </p>
              </div>
            </div>
            <div className={styles.about_astro_main}>
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className={styles.about_astro_main_img}>
                    <Image src={astroside} alt="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={styles.about_astro_main_heading}>
                    <u> Why Choose Senco for Astrological Services?</u>
                  </div>
                  <ul className={styles.list}>
                    <li>
                      A trusted name with years of experience in offering
                      astrological services.
                    </li>
                    <li>
                      Try to meet and exceed the expectations of our customers.
                    </li>
                    <li>
                      Continually strive to provide accurate and detailed
                      predictions.
                    </li>
                    <li>
                      Our astrologers have in-depth and extensive knowledge of
                      the subject.
                    </li>

                    <li>
                      Let you choose from a wide variety of astrological
                      services at affordable prices.
                    </li>
                  </ul>
                  <div className={styles.about_astro_main_call}>
                    {" "}
                    <Link href="/contact-us" passHref>
                      <span className={styles.text_hover}>Contact Us </span>
                    </Link>{" "}
                    to know more about our Astrological Services
                  </div>
                  {/* <a href="tel://18001030017" className={styles.call_number}>
                    18001030017
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.horoscope_bg}>
        <div className="container">
          <div className={styles.horoscope_astro}>
            <div className={styles.horoscope_astro_head}>
              CHECK YOUR <strong>HOROSCOPE</strong>
            </div>
            <div className={styles.wline}>
              <Image src={wline} alt="" />
            </div>
            <div className="row justify-content-center mt-4 mb-4">
              <div className="col-md-6">
                <p className="text-center"> Life is full of possibilities.</p>
              </div>
            </div>
            <div className={styles.icon_container}>
              {!!astro.length &&
                astro.map((v: any) => (
                  <>
                    {" "}
                    <div
                      className={styles.col}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        router.push(`/astro/horoscope/${v.name}`);
                      }}
                    >
                      {/* <Link href="astrohoroscope" passHref> */}
                      <div className={styles.border_full}>
                        <div className={styles.icon_img}>
                          <Image
                            src={v.thumbnail_image}
                            alt=""
                            height={"200px"}
                            width={"200px"}
                          />
                        </div>
                        <p>
                          {v.name}
                          <br /> {moment(v.start_date).format("MMMM DD")} -
                          {moment(v.end_date).format("MMMM DD")}
                        </p>
                      </div>
                      {/* </Link> */}
                    </div>
                  </>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.horoscope_bg_row}>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-5">
              <div className={styles.horoscope_bg_row_img}>
                <Image src={horoscope_img} alt="" />
              </div>
              <div className={styles.horoscope_bg_row_img_heading}>
                Astro Consultation
              </div>
              <Link href="/astro/astrologers" passHref>
                <div className={styles.horoscope_bg_row_button}>Book Now</div>
              </Link>
            </div>
            <div className="col-md-5">
              <div className={styles.horoscope_bg_row_img}>
                <Image src={horoscope_img_two} alt="" />
              </div>
              <div className={styles.horoscope_bg_row_img_heading}>
                Get Kundli
              </div>
              <Link href="/astro/kundali" passHref>
                <div className={styles.horoscope_bg_row_button}>Book Now</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl }) => {
      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle("Online Astrology Services | Senco Gold"));
      store.dispatch(
        setMeta({
          title: "Online Astrology Services | Senco Gold",
          description:
            "Discover elegance at its finest with Senco Gold's best jewellery store near you. Explore exquisite designs crafted for every occasion.",
          keywords: "Online Astrology Services | Senco Gold",
        })
      );

      return {
        props: {},
      };
    }
);

export default Astro;
